import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  handleCurrentPlayVideo,
  setHasInteracted,
  savePlayerState,
  saveScrollY,
} from "../components/slice/sliceSlice";
import { useState } from "react";
import { useSendLogoutMutation } from "../features/api/authApiSlice";
import { useEffect } from "react";

const useVideo = () => {
  const [sendLogout] = useSendLogoutMutation();
  const dispatch = useDispatch();
  const [dataToShow, setDataToShow] = useState(6);

  // ✅ from Redux
  const { selectedVideo, hasInteracted, playerState, scrollY } = useSelector(
    (state) => state.videoSlice
  );

  // Load more
  const handleLoadMore = () => setDataToShow(dataToShow + 3);

  // Scroll to top helper
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Select video
  const handleSelectedVideoToPlay = (video) => {
    dispatch(handleCurrentPlayVideo(video));
    dispatch(setHasInteracted(true));
  };

  // Reset interaction
  const resetInteraction = () => {
    dispatch(setHasInteracted(false));
  };

  // ✅ Persist player state in Redux + sessionStorage
  const persistPlayerState = (updates) => {
    dispatch(savePlayerState(updates));
  };

  const persistScroll = () => {
    dispatch(saveScrollY(window.scrollY));
  };

  // --- Optional: sessionStorage ---
  useEffect(() => {
    if (playerState) {
      sessionStorage.setItem("videoPlayerState", JSON.stringify(playerState));
    }
  }, [playerState]);

  useEffect(() => {
    const saved = sessionStorage.getItem("videoPlayerState");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        dispatch(savePlayerState(parsed)); // ✅ hydrate Redux on load
      } catch (e) {
        console.error("Failed to parse saved playerState", e);
      }
    }
  }, [dispatch]);

  // Utility functions
  const formatDate = (dateString) =>
    new Date(dateString).toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(amount);

  const formatPhoneNumber = (value) => {
    const cleaned = ("" + value).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    return match ? `${match[1]}-${match[2]}-${match[3]}` : value;
  };

  const handleLogout = async () => {
    try {
      const response = await sendLogout();
      toast.success(response?.data?.message);
    } catch (error) {
      toast.error(error?.data?.message);
    }
  };

  return {
    selectedVideo,
    dataToShow,
    hasInteracted,
    playerState,
    scrollY,
    persistPlayerState,
    persistScroll,
    resetInteraction,
    formatDate,
    scrollToTop,
    handleSelectedVideoToPlay,
    handleLoadMore,
    formatCurrency,
    formatPhoneNumber,
    handleLogout,
  };
};

export { useVideo };